import React, { useMemo } from "react";
import { Divider, Logo, NavigationWrapper, NavigationWrapperPermissionView } from "./styles";
import NeoLogo from "assets/svgs/neoInsuranceLogoWhite_risk.svg";
import Menu from "./Menu";
import { Link, useLocation } from "react-router-dom";
import useUser from "hooks/useUser";
import { isPathStrictlyV1, planSetupInProgress, planSetupPendingInProgress, userHasViewPermission } from "utlis/utils";

function Navigation() {
  const { getRole } = useUser();
  const role = getRole();

  const displayMenuItems = () => {
    if (planSetupInProgress() || planSetupPendingInProgress()) {
      return null;
    }
    return (
      <>
        <article>
          <Menu />
        </article>
      </>
    );
  };

  const redirectToCompanySelectionScreen = () => {
    if (JSON.parse(localStorage.getItem("login_profile"))?.is_multiple_company_mapped) {
      const path = window.location.pathname;
      const segments = path.replace(/\/$/, "").split("/");

      // Find where "v1" is in the path
      const v1Index = segments.indexOf("v1");

      // Check if 'v1' is found AND if there is a segment immediately following it
      // Example: ["", "v1", "overview"] -> Index of v1 is 1. Segment at index 2 exists.
      if (v1Index !== -1 && segments[v1Index + 1]) {
        return true
      }
      return false
    }
    return false
  };

  const renderJSX = () => {
    if (userHasViewPermission() && isPathStrictlyV1()) {
      return (
        <>
          <NavigationWrapperPermissionView>
            <header>
              <Link
                to={role === "admin" ? "/" : "#"}
                style={{
                  cursor: role === "admin" ? "pointer" : "default",
                }}
              >
                <Logo role={role} src={NeoLogo} />
              </Link>
              <Divider />
            </header>
            {displayMenuItems()}
          </NavigationWrapperPermissionView>
        </>
      );
    } else {
      return (
        <NavigationWrapper>
          <header>
            <Link
              to={role === "admin" ? "/" : redirectToCompanySelectionScreen() ? "/v1/" : "#"}
              style={{
                cursor: role === "admin" ? "pointer" : redirectToCompanySelectionScreen() ? "pointer" : "default",
              }}
            >
              <Logo role={role} src={NeoLogo} />
            </Link>
            <Divider />
          </header>
          {displayMenuItems()}
        </NavigationWrapper>
      );
    }
  };
  return renderJSX();
}

export default Navigation;
